import React, { Component } from 'react'
import { Button, Form, Card, Col, Modal, Row, Alert, Container } from 'react-bootstrap'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { getConfig, login, resetPassword, clearResult, clearLoginResult, validateToken, requestPwEmail } from '../action/userActions'
import logo from '../../assets/logo.svg'
import loading from '../../assets/loading.svg'
import RequestPwChange from './RequestPwChange'
import ResetPassword from './ResetPassword'
import ForgotPassword from './ForgotPassword'
import SelectPwFunction from './SelectPwFunction'
import connectorImg from '../../assets/IDEA-Connector.jpg'
import '../../css/ewLogin.css'


class ChangePassword extends Component {

    constructor(props) {
        super(props)
        let hasSpecialChars = { valid: false, desc: 'Has 1 Special Character' }
        let hasNum = { valid: false, desc: 'Has 1 Number' }
        let hasUpperCase = { valid: false, desc: 'Has 1 Uppercase Letter' }
        let has8Chars = { valid: false, desc: 'Has At least 8 Characters' }

        let rules = [hasUpperCase, hasNum, hasSpecialChars, has8Chars]

        this.state = { userName: '', password: '', rules, isNewPassValid: false, isConfirmValid: false }
    }

    isValid(str) {
        return new Promise(res => {
            let hasSpecialChars = { valid: /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g.test(str), desc: 'Has 1 Special Character' }
            let hasNum = { valid: /[0-9]/.test(str), desc: 'Has 1 Number' }
            let hasUpperCase = { valid: /[A-Z]/.test(str), desc: 'Has 1 Uppercase Letter' }
            let has8Chars = { valid: str && str.length >= 8, desc: 'Has At least 8 Characters' }

            let rules = [hasUpperCase, hasNum, hasSpecialChars, has8Chars]

            let isNewPassValid = has8Chars.valid && hasNum.valid && hasSpecialChars.valid && hasUpperCase.valid

            this.setState({ rules, newPassword: str, isNewPassValid }, () => res())

        })

    }

    render() {
        //  const passwordIsValid = this.state.password.length > 3
        const params = new URLSearchParams(this.props.location.search);
        const mode = params.get('mode')
        const token = params.get('token')
        this.sa = params.get('sa')
        console.log('mode', mode)
        console.log('token', token)

        if (mode === 'forgot' && token) {
            if (!this.props.user.success && !this.props.loading) {
                if (!this.props.user.fail)
                    this.props.dispatch(validateToken(token))
                else
                    window.location = '/custom/changepassword?mode=forgot'
                return ''
            }
        }

        let ModeForm = (() => {

            let form = ''
            switch (mode) {
                case 'reset':
                    form = <ResetPassword />
                    break;
                case 'request':
                    form = <RequestPwChange />
                    break;
                case 'forgot':
                    form = <ForgotPassword token={token} />
                    break;
                case 'select':
                    form = <SelectPwFunction />
                    break;
                default:
                    form = <div>None</div>
                    break;
            }
            return form
        })

        const LoginModal = (() => {
            if (Object.keys(this.props.user).length > 0) {
                if (this.props.user.fail) {
                    return <Modal show={this.props.user.fail}>
                        <Modal.Body>
                            <Alert variant='danger'>
                                Password Incorrect
                    </Alert>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button onClick={() => {
                                this.props.dispatch(clearLoginResult())
                            }}>
                                Dismiss
                      </Button>
                        </Modal.Footer>
                    </Modal>
                }
            }
            return ''
        })

        const EmailSentModal = (() => {
            let keys = Object.keys(this.props.user)
            let noUser = keys.filter(k => {
                return k === 'noUser'
            })

            if (noUser.length > 0) {

                setTimeout(() => {
                    window.location.reload()
                }, 2500)

                return (

                    <Modal show={true}>
                        <Modal.Body>
                        </Modal.Body>
                        <Alert variant='danger'>
                            Invalid User Name. Please try again.
                        </Alert>
                    </Modal>
                )
            } else if (this.props.user.emailSent) {
                setTimeout(() => {
                    if (!this.sa)
                        window.location = this.props.config.ENTERWORKS_CONFIG.ENABLE_URL
                }, 2500)
                return (
                    <Modal show={true}>
                        <Modal.Body >
                            <Alert variant='success'>
                                Password Reset Email Sent !
                           </Alert>
                        </Modal.Body>
                    </Modal>
                )
            }
            else

                return ''
        })

        const ResultModal = (() => {

            if (!this.props.pwReslt) {
                return ''
            }

            if (this.props.pwReslt.success) {
                return (
                    <Modal show={this.props.pwReslt.success}>
                        <Alert style={{ textAlign: 'center' }} variant='success'>
                            Password Successfully Reset !
                      </Alert>
                    </Modal>
                )
            } else {
                return (
                    <Modal show={!this.props.pwReslt.success}>
                        <Modal.Body>
                            <Alert variant='danger'>
                                Did not reset password
                      </Alert>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button onClick={() => {
                                this.props.dispatch(clearResult())
                            }}>
                                Dismiss
                        </Button>
                        </Modal.Footer>
                    </Modal>
                )
            }
        })
        if (this.props.pwReslt && this.props.pwReslt.success) {
            setTimeout(() => {
                if (!this.sa)
                    window.location = this.props.config.ENTERWORKS_CONFIG.ENABLE_URL
            }, 2000);
        }
        return (
            <Container >
                <img style={{ position: 'fixed', left: '0', right: '0', width: '100%', height: '100%' }} src={connectorImg} />

                <Row>
                    <Col>
                    </Col>
                    <Col style={{ marginTop: '120px' }} sm='10' md='10' xs='10' lg='6' xl='6'>

                        <Card style={{ boxShadow: '5px 10px 8px' }} >
                            <Card.Img style={{ minWidth: '200px', maxWidth: '250px', margin: 'auto', paddingTop: '25px' }} variant='top' src={logo} />

                            <Card.Body>
                                <img hidden={!this.props.loading} src={loading} />
                                <ModeForm />
                            </Card.Body>
                        </Card>

                    </Col>
                    <Col >
                        {/*       <div className = 'loginContent'>
                
                    <div className='middleContent'>
                    The Right Content. IDEA'd.
                    </div>
                    <div className='smallerMiddle'>
                        
                    Deliver differentiated experiences across your content value chain with IDEA, your Product Information Management solution.
                                    
                    </div>

                    </div> */}
                    </Col>



                    <ResultModal />
                    <LoginModal />
                    <EmailSentModal />
                </Row>

            </Container>

        )
    }

    componentDidMount() {
        this.props.dispatch(getConfig())
    }
}

const mapStateToProps = state => ({
    user: state.acct.user.loggedInUser,
    config: state.acct.user.config,
    loading: state.acct.user.loading,
    pwReslt: state.acct.user.resetPasswordResult,
    pwError: state.acct.user.resetPwError
})

export default withRouter(connect(mapStateToProps)(ChangePassword))